import React, { useEffect, useRef } from "react";

import mergeRefs from "merge-refs";

import { CheckboxInputStyle } from "./styles";

export type CheckboxInputProps = {
  id: string;
  checked?: boolean | null;
  indeterminate?: boolean | null;
  onChangeValue?: (value: boolean) => void;
  hasError?: boolean;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "color" | "id" | "checked" | "ref" | "label">;

export const CheckboxInput = React.forwardRef<HTMLInputElement, CheckboxInputProps>(
  (
    { indeterminate, onChange, onChangeValue, className, style, hasError, disabled, ...props },
    ref
  ) => {
    const inputRef = useRef<HTMLInputElement>();

    useEffect(() => {
      if (inputRef.current) inputRef.current.indeterminate = !!indeterminate;
    }, [inputRef, indeterminate]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(event);
      onChangeValue?.(event.target.checked);
    };

    return (
      <CheckboxInputStyle
        disabled={disabled}
        hasError={hasError}
        className={className}
        style={style}
      >
        <CheckboxInputStyle.Input
          disabled={disabled}
          ref={mergeRefs(inputRef, ref)}
          type="checkbox"
          onChange={handleChange}
          {...props}
        />
      </CheckboxInputStyle>
    );
  }
);
